module.exports = __webpack_public_path__ + "media/images/Share_Site_Footer_2x-7058d10a.png";